import { FC } from 'react';
import countryFlags from '../../../../../assets/countryFlags.json';
import { Select } from '../../Select';
import { Text } from '../../../Text';
import { Flex } from '../../../Flex';
import countryPickerStyle from './CountryPicker.style.tsx';

export const CountryPicker: FC<{ value?: string; onChange?: (e: any) => void; phone?: boolean }> = (props: any) => {
  let style = countryPickerStyle();

  return (
    <Select
      popupMatchSelectWidth={false}
      onChange={props?.onChange}
      value={props.value}
      options={Object.keys(countryFlags).map((name) => {
        return !props.phone
          ? {
              label: (
                <Flex justify="start" align="center" gap={6} style={style.label}>
                  <div style={style.flag}>
                    <Text size={40} style={style.flagText}>
                      {(countryFlags as any)[name][0]}
                    </Text>
                  </div>
                  <Text size={12}>{name}</Text>
                </Flex>
              ),
              value: name,
            }
          : {
              label: (
                <Flex justify="start" align="center" gap={6} style={style.label}>
                  <div style={style.flagPhone}>
                    <Text size={40} style={style.flagText}>
                      {(countryFlags as any)[name][0]}
                    </Text>
                  </div>
                  <Text size={12}>{(countryFlags as any)[name][1]}</Text>
                  <Text size={10} style={style.phoneText}>
                    {(countryFlags as any)[name][2]}
                  </Text>
                </Flex>
              ),
              value: (countryFlags as any)[name][2],
            };
      })}
      placeholder="Select"
    />
  );
};

export default CountryPicker;
